module.exports = __webpack_public_path__ + "static/media/1005664.c0feccbd.jpg";